import { get, chain, filter, some } from 'lodash';
import { extract } from 'ricos-content/libs/extract';
import { Node_Type } from 'ricos-schema';
import { getRichContentText } from './get-rich-content-text';
import { isRichContent } from './is-rich-content';
export const getImageCount = (content) => {
    if (isRichContent(content)) {
        return getNodeCount(content, Node_Type.IMAGE);
    }
    return filter(content.entityMap, (entity) => entity.type === 'wix-draft-plugin-image').length;
};
export const getGiphyCount = (content) => {
    if (isRichContent(content)) {
        return getNodeCount(content, Node_Type.GIF);
    }
    return filter(content.entityMap, (entity) => entity.type === 'wix-draft-plugin-giphy').length;
};
export const getVideoCount = (content) => {
    if (isRichContent(content)) {
        return getNodeCount(content, Node_Type.VIDEO);
    }
    return filter(content.entityMap, (entity) => entity.type === 'wix-draft-plugin-video').length;
};
export const getQuoteCount = (content) => {
    if (isRichContent(content)) {
        return getNodeCount(content, Node_Type.BLOCKQUOTE);
    }
    return filter(content.blocks, (block) => block.type === 'blockquote').length;
};
export const getCharacterCount = (content) => {
    if (isRichContent(content)) {
        return getRichContentText(content, '').length;
    }
    return filter(content.blocks, (block) => block.type !== 'atomic').reduce((count, block) => get(block, 'text', '').length + count, 0);
};
export const hasHtml = (content) => {
    if (isRichContent(content)) {
        return getNodeCount(content, Node_Type.HTML) > 0;
    }
    return some(content.entityMap, (entity) => entity.type === 'wix-draft-plugin-html');
};
export const getGalleries = (content) => {
    if (isRichContent(content)) {
        const galleries = extract(content.nodes)
            .filter(({ type }) => type === Node_Type.GALLERY)
            .map(({ galleryData }) => ({
            layout: galleryData.options.layout.type,
            length: galleryData.items.length,
        }))
            .get();
        return galleries.length ? JSON.stringify(galleries) : null;
    }
    const galleries = chain(content.entityMap)
        .filter((entity) => entity.type === 'wix-draft-plugin-gallery')
        .map((entity) => ({
        layout: entity.data.config.layout,
        length: entity.data.items.length,
    }))
        .value();
    return galleries.length ? JSON.stringify(galleries) : null;
};
const getNodeCount = (content, nodeType) => {
    return extract(content.nodes)
        .filter(({ type }) => type === nodeType)
        .get().length;
};
//# sourceMappingURL=content-selectors.js.map